<script>
import { AgGridVue } from 'ag-grid-vue3'
import 'ag-grid-enterprise'
import { LicenseManager } from 'ag-grid-enterprise'
import { defineComponent } from 'vue';
LicenseManager.setLicenseKey('CompanyName=Revolution Payroll,LicensedGroup=ProBooks,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-011578,ExpiryDate=4_December_2021_[v2]_MTYzODU3NjAwMDAwMA==5da9d3c2699f550dc7daf171582ca3ed')

import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';
import '../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css';

export default defineComponent ({
  name: 'AgGrid',

  emits: ['update-totals'],

  components: {
    AgGridVue
  },

  props: {
    // Name of input field.  Not really necessary, but helpful if we use the form object down the road
    name: {
      required: true,
      type: String
    },
    getRowStyle: {
      required: false,
      type: Function,
      default: null
    },
    reference: {
      required: false,
      type: String
    },

    iteration: {
      required: true,
      type: Number
    },

    width: {
      required: true,
      type: String
    },

    height: {
      required: true,
      type: String
    },

    classes: {
      required: false,
      type: String,
      default: 'ag-theme-balham'
    },

    rowData: {
      required: false
    },

    // Ag-grid column defs
    columns: {
      required: false,
      type: Array,
      default: undefined
    },

    sidebar: {
      required: false,
      type: String,
      default: null
    },

    filterOrder: {
      required: false,
      type: Array,
      default: null
    },

    // Ag-grid Options
    options: {
      required: false,
      type: Object,
      default: undefined
    }
  },

  data () {
    return {
      isError: false, // If the input or selected field is incorrect, show an error
      isLoading: false,
      scope: this,
      gridApi: null,
      columnApi: null,
      defaultColDefs: undefined,
      defaultGridOptions: undefined,
      changes: [],
      filterBar: {
        toolPanels: [
            {
                id: 'filters',
                labelDefault: 'Filter Results',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
                toolPanelParams: {
                    suppressExpandAll: false,
                    suppressFilterSearch: true,
                    suppressSyncLayoutWithGrid: true,
                },
            },
        ],
        defaultToolPanel: '',
        hiddenByDefault: true,
      }
    }
  },

  computed: {
    columnDefs () {
      if (this.columns && Array.isArray(this.columns)) {
        return this.columns
      } else {
        return this.defaultColDefs
      }
    },
    gridOptions () {
      return this.options || this.defaultGridOptions
    },

    // Any groups with at least one transaction selected
    selectedGroups () {
      let aggregatedNodes = []
      this.gridApi.forEachNode((node) => {
        if (node.aggData) {
          const selected = node.allLeafChildren.find((child) => child.selected)
          if (selected) aggregatedNodes.push(node)
        }
      })
      return aggregatedNodes
    },
  },

  methods: {
    removeSelectedRow() {
      // to get selected data
      const selectedRow = this.gridApi.getSelectedRows();
      if (!selectedRow || !selectedRow[0]) return;
      let selectedId = selectedRow[0].id;
      this.gridApi.applyTransaction({remove: selectedRow}); // remove data in grid
      let selectedIdx = this.rowData.findIndex((row) => row.id == selectedId);
      if (selectedIdx != -1) {
        this.rowData.splice(selectedIdx,1); // remove data in rowData
      }
    },
    reDraw() {
      // refresh all rows
      this.gridApi.redrawRows();
    },
    updateTotals (gridApi) {
      const api = gridApi || this.gridApi
      if (!api) return

      let sum = 0
      let selected = 0
      api.forEachNode((row) => {
        if (row && row.data && row.data.attributes) {
          sum += parseFloat(row.data.attributes.amount_decimal || '0')
          if (row.selected) {
            selected += parseFloat(row.data.attributes.amount_decimal || '0')
          }
        }
      })
      this.$emit('update-totals', {
        totalAvailable: sum.toFixed(2),
        totalSelected: selected.toFixed(2)
      })
    },

    // For this, the real node/row is selectable if the routing and bank account exists on the vendor
    isRowSelectable (params) {
      return false;
    },

    // Ag-grid
    reset() {
        this.gridOptions.api.setSideBarVisible(false)
    },
    onGridReady (event) {
      if (!event) return
      this.gridApi = event.api
      this.columnApi = event.columnApi
      if (this.filterOrder) {
        this.onCallCustomSortFilter(this.filterOrder);
        this.gridOptions.api.setSideBarVisible(true)
      }
    },

    onFirstDataRendered (event) {
      if (!event) return
      if (event.api.gridPanel.bodyHeight) event.api.sizeColumnsToFit()
      this.updateTotals(event.api)
    },

    onCellValueChanged (event) {
      // Ignore if not changed
      if ((event.value && event.oldValue === event.newValue) || !event.data) return
    },

    onChangeVisibleColumns () {
      this.$nextTick(() => {
        this.gridApi.sizeColumnsToFit()
      })
    },

    exportToExcel () {
      this.gridApi.exportDataAsExcel()
    },

    onCallCustomSortFilter (options) {
      if (!options) return;
      const filtersToolPanel = this.gridOptions.api.getToolPanelInstance('filters'); 

      // set custom Filters Tool Panel layout
      filtersToolPanel.setFilterLayout(this.filterOrder);
    }
  },

  beforeMount () {
    this.defaultColDefs = []

    this.defaultGridOptions = {
      singleClickEdit: false,
      undoRedoCellEditing: false,
      enterMovesDown: false,
      enterMovesDownAfterEdit: false,
      rowSelection: 'multiple',
      defaultColDef: {
        resizable: true,
        sortable: true,
        menuTabs: [],
        suppressSizeToFit: false
      },
      pinnedBottomRowData: [],
      enableRangeSelection: true,
      animateRows: true,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',

      // Grouping related
      suppressAggFuncInHeader: true,
      groupSelectsChildren: true,
      autoGroupColumnDef: {
        headerName: 'Client',
        minWidth: 200,
        cellRendererParams: {
          suppressCount: true
        }
      },
      aggFuncs: {
        sum: this.customSum, // this overrides the grids built in sum function
        sumSelected: this.customSumSelected
      },

      // Classes and events
      rowClassRules: {
        'ag-error': (params) => !params.data
      },

      excelStyles: [
        {
          id: 'amount',
          numberFormat: {
            format: '#,##0.00'
          }
        },
        {
          id: 'textFormat',
          dataType: 'string'
        }
      ],
      onGridReady: (event) => this.onGridReady(event),
      onFirstDataRendered: (event) => this.onFirstDataRendered(event),
      onCellValueChanged: (event) => this.onCellValueChanged(event),
      onSelectionChanged: (event) => {
        this.updateTotals(event.api)
        this.gridApi.refreshClientSideRowModel('aggregate')
      }
    }
  }
});
</script>

<template>
<div>
  <ag-grid-vue
    :name="name"
    :ref="reference || name"
    :class="classes"
    :style="{ width, height }"
    :key="iteration"
    :column-defs="columnDefs"
    :row-data="rowData"
    :grid-options="gridOptions"
    :side-bar="filterBar"
    :get-row-style="getRowStyle"
  />
</div>
</template>

<style lang="css">
.ag-side-button {
	 background-color: #fc0 50;
	 color: red;
	 font-weight: 900;
}
</style>
